import styled from '@emotion/styled';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';
import { Logo } from '../../atoms/logo/logo';
import { IconText } from '../icon-text/icon-text';
import { TypographyProps } from '../../atoms/typography/typography';

interface ImageIconTextProps {
  altName: string;
  src: string;
  icon?: string;
  iconPosition?: 'left' | 'right';
  text: string;
  textVariant?: TypographyProps['variant'];
  onClick: () => void;
}

export const ImageIconText = ({
  altName,
  src,
  icon = 'arrow_forward',
  iconPosition = 'right',
  text,
  textVariant,
  onClick,
}: ImageIconTextProps) => (
  <StyledLogoWrapper onClick={onClick}>
    <Logo altName={altName} src={src} width={137} />
    <IconText
      icon={icon}
      text={text}
      textVariant={textVariant}
      iconPosition={iconPosition}
    />
  </StyledLogoWrapper>
);

const StyledLogoWrapper = styled.div`
  background-color: var(--md-sys-color-surface);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--rk-spacing-md);
  width: 50%;
  border-radius: var(--rk-spacing-lg);
  border: 1px solid var(--md-sys-color-shadow);
  padding: var(--rk-spacing-lg);
  cursor: pointer;
  ${mq(BreakpointSizes.xs)} {
    width: 75%;
  }
  img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }
`;
